
import BookingTable from '../../Components/Admin/BookingTable'
import Title from '../../Components/Admin/Title'
import { FaChartArea, FaRegBuilding, } from 'react-icons/fa'

function Dashboard() {

    return (

        <>
            <Title icon={FaChartArea} title='Dashboard' />



            <div className='grid grid-cols-4 gap-3'>
                <div className="bg-primary p-4 relative">
                    <div><h3 className="text-xl text-white">Total Mandaps</h3></div>

                    <FaRegBuilding className='absolute bottom-0 right-0 text-white text-5xl' />
                </div>
                <div className="bg-accent p-4">
                    <div><h3 className="text-xl text-white">Total Mandaps</h3></div>
                    <FaRegBuilding />
                </div>
                <div className="bg-warning p-4">
                    <div><h3 className="text-xl text-white">Total Mandaps</h3></div>
                    <FaRegBuilding />
                </div>
                <div className="bg-secondary p-4">
                    <div><h3 className="text-xl text-white">Total Mandaps</h3></div>
                    <FaRegBuilding />
                </div>
            </div>

            <BookingTable />
        </>
    )
}

export default Dashboard